<template>
    <v-app>
        <Sidebar v-if="this.$store.getters.isAuthenticated" :drawer="drawer"></Sidebar>
        <Header @drawer-change="headerDrawerChange"></Header>
        <v-content>
            <ResponseNotification></ResponseNotification>
            <router-view/>
        </v-content>
    </v-app>
</template>

<script>
    import Sidebar from './components/Sidebar.vue';
    import Header from './components/Header.vue';
    import ResponseNotification from './components/ResponseNotification.vue';

    export default {
        name: 'App',
        components: {
            Sidebar,
            Header,
            ResponseNotification
        },
        data: () => ({
            drawer: null
        }),
        methods: {
            headerDrawerChange(drawer) {
                this.drawer = drawer;
            }
        }
    };
</script>
